import { render, staticRenderFns } from "./JobEdit.vue?vue&type=template&id=2bd8b6bc"
import script from "./JobEdit.js?vue&type=script&lang=js&external"
export * from "./JobEdit.js?vue&type=script&lang=js&external"
import style0 from "./JobEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports